<template>
  <section>
    <b-container fluid>
      <el-carousel
        :autoplay="autoPlay"
        :interval="4444000"
        arrow="hover"
        class="banner-info"
        :height="bannerHeight + 'px'"
        @mouseenter.native="MouseEnter"
        @mouseleave.native="MouseLeave"
      >
        <el-carousel-item
          class="item-bg"
          v-for="(item, index) in bannerList"
          :key="index"
        >
          <div
            v-if="item.fileType == '.mp4'"
            :style="{ height: bannerHeight + 'px' }"
          >
            <div id="playVideoBanner" :style="{ height: bannerHeight + 'px' }" >
              <video
              v-if="videoPlayer"
                ref="vdo"
                id="playVideo"
                class="video-js vjs-default-skin vjs-big-play-centere  "
                preload="auto"
                width="100%"
                style="object-fit: cover;"
              ></video>
              <!-- <video
              muted
              width="100%"
              ref="vdo"
              
              autoplay
              loop
              :src="item.video"
              class="avatar"
              :height="bannerHeight + 'px'"
            ></video> -->
            </div>
          </div>

          <!-- :src="uploadBaseUrl+'/server/api/video/player?id='+item.id" -->
          <!-- <el-image  v-else :src="uploadBaseUrl+'/server/api/file/getFile?id='+item.id"   width="100%" ></el-image> -->

          <el-image
            v-else
            ref="bannerHeight"
            :src="item.img"
            :style="bgStyle"
          ></el-image>
        </el-carousel-item>
        <div class="justify-content-center bot-box">
          <div class="bot-box-wrap">
            <b-container
              fluid
              class="bot-content d-flex align-items-center"
              :style="{ height: botHeight + 'px' }"
            >
              <b-row
                class="text-center justify-content-center align-items-center bot-w d-flex"
                style="width: 100%"
              >
                <b-col
                  cols="12"
                  md="9"
                  lg="9"
                  xl="9"
                  class="text-center justify-content-center d-flex align-items-center"
                >
                  <b-container fluid>
                    <b-row class="text-center">
                      <b-col
                        cols="6"
                        sm="3"
                        style="width: 100%; padding: 5px 0"
                        class="flex-column justify-content-between align-items-center d-flex bot-item"
                        v-for="(val, i) in datas"
                        :key="i"
                      >
                        <div>
                          <div class="topnum">
                            <img :src="val.icon" :style="imgStyle" />
                            <countTo
                              ref="ct3"
                              :startVal="startVal"
                              :endVal="val.num > maxnum ? maxnum : val.num"
                              :duration="3000"
                              :style="spanStyle"
                            ></countTo>
                            <span
                              v-if="val.num > maxnum"
                              style="font-weight: bold"
                            >
                              +
                            </span>
                          </div>
                          <div class="name-tip" :style="span2Style">
                            {{ val.name }}
                          </div>
                        </div>
                      </b-col>
                    </b-row>
                  </b-container>
                </b-col>
              </b-row>
            </b-container>
          </div>
        </div>
      </el-carousel>
    </b-container>
  </section>
</template>
<script>
import countTo from "vue-count-to";
import utils from "@/utils/commonUrl.js";
import "video.js/dist/video-js.css";
import videojs from "video.js";
import "videojs-contrib-hls";
export default {
  components: {
    countTo,
  },
  data() {
    return {
      playVideoUrL: utils.videoUrl,
      bannerList: [],
      videoPlayer: "",
      datas: [],
      bannerHeight: 800,
      botHeight: 180,
      imgStyle: {
        width: 45,
        height: 45,
        marginTop: 8,
      },
      spanStyle: {
        fontSize: 60,
        marginLeft: 8,
      },
      span2Style: {
        fontSize: 24,
        lineHeight: 2.2,
      },
      bgStyle: {
        width: "100%",
        bannerHeight: 800,
      },
      fontSize: 40,
      // 浏览器宽度
      screenWidth: 0,
      startVal: 0,
      endVal: 2000,
      isQQ: false,
      autoPlay: true,
      maxnum: 9999999,
    };
  },
  watch: {},
  created() {
    // this.is_weixn_qq();
  },
  beforeDestroy(){
    var that = this;
    if(that.videoPlayer){
      that.videoPlayer.dispose()
    }
  },
  mounted() {
   
    // banner视频加载
    // this.disposeVideo();
    // 首次加载时,需要调用一次
    this.screenWidth = window.innerWidth;
    this.setSize();
    // 窗口大小发生改变时,调用一次

    window.onresize = () => {
      this.screenWidth = window.innerWidth;
      this.setSize();
    };
    this.getBanner();
    
    this.getDatas();
      
    this.bofang();
    // if (this.$refs.vdo) this.$refs.vdo[0].play();
    
  },
  methods: {
   
    MouseEnter() {
      this.autoPlay = false;
    },
    MouseLeave() {
      this.autoPlay = true;
    },
    is_weixn_qq() {
      var ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        // alert("weixin");
      } else if (ua.match(/QQ/i) == "qq") {
        this.isQQ = true;
        // alert("QQ");
      } else if (ua.match(/chrome/i == "chrome")) {
        // alert("chrome");
      } else {
        // alert(ua);
      }
    },
    setSize: function () {
      // 通过浏览器宽度(图片宽度)计算高度

      if (this.screenWidth > 576) {
        this.bannerHeight = (800 / 1920) * this.screenWidth;
        this.botHeight = (180 / 1920) * this.screenWidth;
        this.imgStyle.width = (45 / 1920) * this.screenWidth + "px";
        this.imgStyle.height = (45 / 1920) * this.screenWidth + "px";
        this.imgStyle.marginTop = (8 / 1920) * this.screenWidth + "px";
        this.bgStyle = {
          height: (800 / 1920) * this.screenWidth + "px",
          width: "100%",
        };
        this.spanStyle = {
          fontSize: (60 / 1920) * this.screenWidth + "px",
          marginLeft: (5 / 1920) * this.screenWidth + "px",
        };
        this.span2Style = {
          fontSize: (24 / 1920) * this.screenWidth + "px",
          lineHeight: (2.5 / 1920) * this.screenWidth,
        };
      } else {
        this.isQQ = true;
        this.bannerHeight = ((800 * 2) / 1920) * this.screenWidth;
        this.bgStyle = {
          height: ((800 * 2) / 1920) * this.screenWidth + "px",
          width: "150%",
          left: "-22%",
        };
        this.botHeight = ((180 * 3) / 1920) * this.screenWidth;
        this.imgStyle.width = ((45 * 2) / 1920) * this.screenWidth + "px";
        this.imgStyle.height = ((45 * 2) / 1920) * this.screenWidth + "px";
        this.imgStyle.marginTop = ((0.5 * 1) / 1920) * this.screenWidth + "px";

        this.spanStyle = {
          fontSize: ((60 * 1.8) / 1920) * this.screenWidth + "px",
          marginLeft: ((5 * 1.5) / 1920) * this.screenWidth + "px",
        };
        this.span2Style = {
          fontSize: ((24 * 2.5) / 1920) * this.screenWidth + "px",
          lineHeight: ((2.2 * 3) / 1920) * this.screenWidth,
        };
      }
      // this.fontSize1 = 60 / 1920 * this.screenWidth + 'px';
      // this.fontSize = 40 / 1920 * this.screenWidth + 'px';
      // console.log("jjj", this.bannerHeight, this.screenWidth);
    },

    imgLoad() {
      this.$nextTick(() => {
        let ref = this.$refs;
        this.bannerHeight =
          ref.bannerHeight && ref.bannerHeight.length
            ? ref.bannerHeight[0].height
            : "";
        // console.log("2132", ref.bannerHeight[0], "ppp", this.bannerHeight);
      });
    },
    getDatas() {
      this.datas = [
        {
          id: "011",
          icon: require("@/assets/images/index/ban_airport_icon.png"),
          num: 244,
          name: "运输机场",
        },
        {
          id: "012",
          icon: require("@/assets/images/index/ban_com_icon.png"),
          num: 68,
          name: "运输航空公司",
        },
        {
          id: "013",
          icon: require("@/assets/images/index/ban_aircraft_icon.png"),
          num: 4484,
          name: "运输航空器",
        },
        {
          id: "014",
          icon: require("@/assets/images/index/ban_wu_icon.png"),
          num: 822485,
          name: "无人机",
        },
      ];
    },
    getBanner() {
      let bannerData = [
        {
          id: "01",
          img: require("@/assets/images/index/banner/banner1.png"),
          video: require("@/assets/images/index/banner/banner1.png"),
          // video: require("@/assets/videos/banner.mp4"),
          fileType: ".mp4",
        },
        {
          id: "02",
          img: require("@/assets/images/index/banner/banner1.png"),
          fileType: ".png",
        },
        {
          id: "03",
          img: require("@/assets/images/index/banner/banner2.png"),
          img_title: "健康活力 共筑中国梦",
          fileType: ".png",
        },
        {
          id: "04",
          img: require("@/assets/images/index/banner/banner3.png"),
          fileType: ".png",
        },
      ];
      if (this.isQQ == false) {
        this.bannerList = bannerData;
      } else {
        this.bannerList = bannerData.slice(1, 4);
      }
      
    },
    disposeVideo() {
      this.$nextTick(()=>{
        var videoPlayer = $("#playVideo").get(0);
        if (typeof videoPlayer != "undefined") {
          this.videoPlayer.pause();
          this.videoPlayer.dispose();
        }
      })
    },
    bofang() {
      var _this = this;
      _this.bannerList.forEach((item) => {
        if (item.fileType == ".mp4") {
          // _this.disposeVideo();
          _this.$nextTick(() => {
            // 加载视频
            // _this.videoPlayer.dispose();
            // let v_src =  "https://www.caacic.cn/banner.m3u8";
            let v_src = _this.playVideoUrL + "/banner.m3u8";
            // let v_src = item.video;
            let img = require("@/assets/images/index/banner/banner1.png")
          
            let options = {
              autoplay: true,
              controls: false,
              loop: true,
              muted: true,
              // poster:img,
              // width: _this.screenWidth * 1.5,
              height: _this.bannerHeight,
            };
            // console.log("jjjjyyyy",_this.videoPlayer,_this.screenWidth, _this.bannerHeight,options);
            $("#playVideoBanner").html(
              ` <video ref="vdo" id="playVideo" class="video-js vjs-default-skin vjs-big-play-centered" width="100%" style="object-fit: cover;"  preload="auto"  v-if="videoPlayer"></video>`
            );
            // _this.videoPlayer = videojs("playVideo", options);
            
            _this.videoPlayer = videojs("playVideo", options,function onPlayerReady(){
              // this.on('seeking',function() {
              //     var canvas = document.createElement('canvas');
              //     var ctx = canvas.getContext('2d');
              //     canvas.width = _this.videoPlayer.videoWidth();
              //     canvas.height = _this.videoPlayer.videoHeight();
              //     ctx.drawImage(_this.videoPlayer.el(), 0, 0, canvas.width, canvas.height);
              //     var imgData = canvas.toDataURL();
              //     console.log(imgData);
              //   });
            })
            // _this.videoPlayer.on('loadedmetadata',()=>{
            // })
            
          // _this.videoPlayer.currentTime(0);
          // _this.videoPlayer.trigger('seeking');
          //  _this.videoPlayer.poster(img);
            _this.videoPlayer.src({ src: v_src, type: "application/x-mpegURL" });
          });
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
  /deep/.video-js{
    width: 100%;
    object-fit:cover;
  }
/* .el-carousel__item:nth-child(1) {
  background: url(../../../assets/images/index/banner/banner1.png) no-repeat;
  background-size: 100% 100%;
}
.el-carousel__item:nth-child(2) {
  background: url(../../../assets/images/index/banner/banner2.png) no-repeat;
  background-size: 100% 100%;
}
.el-carousel__item:nth-child(3) {
  background: url(../../../assets/images/index/banner/banner3.png) no-repeat;
  background-size: 100% 100%;
}
.el-carousel__item:nth-child(4) {
  background: url(../../../assets/images/index/banner/banner3.png) no-repeat;
  background-size: 100% 100%;
} */
.avatar {
  /* height: 100%; */
}
.name-tip {
  font-family: "PingFang Bold";
}
.v-align span {
  font-family: "DINCond-Black", "Microsoft YaHei";
}

video {
  object-fit: cover;
}
/deep/.el-carousel--horizontal {
  overflow: hidden;
}
/* /deep/.el-carousel__container {
    position: relative;
    height: 800px;
  } */
/deep/.el-carousel__indicators--horizontal {
  position: absolute;
  left: 50%;
  margin: 0 auto;
  top: 70%;
  text-align: right;
}
/deep/ .el-carousel__indicator--horizontal button {
  width: 70px;
  height: 4px;
  background: #66719c;
  margin-right: 13px;
}

/deep/ .el-carousel__indicator--horizontal.is-active button {
  width: 70px;
  height: 4px;
  background: #b3b8ce;
}
.topnum {
  display: flex;
  align-content: center;
  justify-content: center;
  /* background-color: rgba(0, 0, 0, .23); */
}
@media (max-width: 575px) {
  /deep/.el-carousel__indicators--horizontal {
    position: absolute;
    left: 50%;
    margin: 0 auto;
    top: 55%;
    text-align: right;
  }
  /deep/ .el-carousel__indicator--horizontal button {
    width: 30px;
    height: 4px;
    background: #66719c;
    margin-right: 0px;
  }

  /deep/ .el-carousel__indicator--horizontal.is-active button {
    width: 30px;
    height: 4px;
    background: #b3b8ce;
  }
  .bot-item:nth-child(odd) .name-tip {
    text-align: center;
  }
  .bot-item:nth-child(even) .name-tip {
    text-align: center;
  }
  .bot-item:nth-child(odd) .topnum {
    display: flex;
    align-content: center;
    text-align: center;

    /* background-color: rgba(0, 0, 0, .23); */
  }
  .bot-item:nth-child(even) .topnum {
    display: flex;
    align-content: center;
    text-align: center;
    justify-content: center;
    /* background-color: rgba(0, 0, 0, .23); */
  }
}
@media (min-width: 576px) and (max-width: 767px) {
  /deep/.el-carousel__indicators--horizontal {
    position: absolute;
    left: 50%;
    margin: 0 auto;
    top: 65%;
    text-align: right;
  }
  /deep/ .el-carousel__indicator--horizontal button {
    width: 40px;
    height: 4px;
    background: #66719c;
    margin-right: 0px;
  }

  /deep/ .el-carousel__indicator--horizontal.is-active button {
    width: 40px;
    height: 4px;
    background: #b3b8ce;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  /deep/.el-carousel__indicators--horizontal {
    position: absolute;
    left: 50%;
    margin: 0 auto;
    top: 65%;
    text-align: right;
  }
  /deep/ .el-carousel__indicator--horizontal button {
    width: 40px;
    height: 4px;
    background: #66719c;
    margin-right: 0px;
  }

  /deep/ .el-carousel__indicator--horizontal.is-active button {
    width: 40px;
    height: 4px;
    background: #b3b8ce;
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  /deep/.el-carousel__indicators--horizontal {
    position: absolute;
    left: 50%;
    margin: 0 auto;
    top: 68%;
    text-align: right;
  }
  /deep/ .el-carousel__indicator--horizontal button {
    width: 70px;
    height: 4px;
    background: #66719c;
    margin-right: 13px;
  }

  /deep/ .el-carousel__indicator--horizontal.is-active button {
    width: 70px;
    height: 4px;
    background: #b3b8ce;
  }
}
</style>
